// This file is auto-generated during build. Do not edit manually.
export const SDK_VERSION = '2.2.1' as const
